<template>
  <div
    class="modal-window-overlay"
    :class="{ 'modal-window-overlay--open': info }"
  >
    <div class="popup">
      <img
        class="popup__img"
        :src="require(`@/assets/img/${card.img}-2x.png`)"
      />
      <div class="modal-window-title-content">
        <h3>{{ card.title }}</h3>
        <div class="close-window" href="#">
          <close-icon @click="$emit('closeModal')"></close-icon>
        </div>
        <div class="content-window">
          <h5 v-html="card.modalText"></h5>
        </div>
      </div>
      <div class="modal__arrows">
        <div class="modal__arrow modal__arrow--left">
          <chevron-left-icon @click="prevInfo()"></chevron-left-icon>
        </div>
        <div class="modal__arrow modal__arrow--right">
          <chevron-right-icon @click="nextInfo()"></chevron-right-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      card: null,
      currentCard: null,
      img: null
    };
  },
  props: {
    info: {
      type: String,
      required: true
    }
  },
  methods: {
    prevInfo() {
      let temp = Number(this.card.img.split('illust')[1]);
      if (temp === 2) {
        this.card = this.$store.getters.GET_CARD(`info3`);
      } else {
        this.card = this.$store.getters.GET_CARD(`info${temp - 2}`);
      }
    },
    nextInfo() {
      let temp = Number(this.card.img.split('illust')[1]);
      if (temp === 4) this.card = this.$store.getters.GET_CARD(`info1`);
      else if (temp === 2) this.card = this.$store.getters.GET_CARD(`info2`);
      else this.card = this.$store.getters.GET_CARD(`info3`);
    }
  },
  beforeMount() {
    this.card = this.$store.getters.GET_CARD(this.info);
  }
};
</script>

<style lang="scss" scoped>
.modal-window-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  -webkit-transition: opacity 500ms;
  transition: opacity 500ms;
  visibility: hidden;
  opacity: 0;
  display: flex;
  z-index: 100;
  font-family: Roboto;
}

.modal-window-overlay--open {
  visibility: visible;
  opacity: 1;
}

.popup {
  padding: 2.5rem;
  background: $white;
  border-radius: 1.3rem;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  height: 70%;
  transition: all 1s ease-in-out;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
  @include mq-max(1200px) {
    flex-direction: column;
    height: 95%;
    overflow: scroll;
  }
  @include mq-max(450px) {
    width: 95%;
  }
}

.popup .close-window {
  display: inline;
  position: absolute;
  right: 3rem;
  top: 3rem;
  width: 4rem;
  height: 4rem;
  transition: all 200ms;
  text-decoration: none;
  font-size: 3rem;
  background-color: $primary;
  color: $white;
  border-radius: 50%;
  cursor: pointer;
  @include mq-max(450px) {
    right: 2rem;
    top: 2rem;
  }
}

.popup .close-window:hover {
  color: #ff8657;
}

.modal-window-overlay img {
  max-height: 41.5rem;
  width: 40%;
  @include mq-max(1200px) {
    max-height: unset;
    width: 70%;
  }
}

.modal-window-title-content {
  width: 40%;
  @include mq-max(1200px) {
    width: 90%;
    margin-top: 2.5rem;
  }
}
.material-design-icon > .material-design-icon__svg {
  bottom: -5px;
  right: -5px;
}

.popup h3 {
  color: #666;
  font-size: 4.8rem;
  font-weight: 700;
  letter-spacing: -0.4rem;
  line-height: 5rem;
  display: inline-block;
  margin-bottom: 2.4rem;
  @include mq-max(450px) {
    font-size: 3.8rem;
  }
}

.popup h5 {
  color: #666;
  font-size: 2rem;
  font-weight: 300;
  line-height: 2.4rem;
  letter-spacing: 0;
  display: block;
  justify-content: left;
  @include mq-max(450px) {
    font-size: 1.4rem;
  }
  @include mq-max(400px) {
    line-height: 1.4rem;
  }
}

.modal {
  &__arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 8rem;
    color: $primary;
    cursor: pointer;
    &:hover {
      color: $primary-light;
    }
    @include mq-max(450px) {
      top: 20%;
      transform: unset;
    }
    &--right {
      right: 2%;
      @include mq-max(450px) {
        right: -1.5rem;
      }
    }
    &--left {
      left: 0;
      @include mq-max(450px) {
        left: -2.5rem;
      }
    }
  }
}
</style>
